import Categroy from "layout/Category";
import Layout from "layout/Layout";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { medmall_logo } from "utils/linkData";

import { API_SERVER_URL } from "utils/config";
import Pagenation from "utils/Pagenation";
import { requestGet } from "utils/AxiosApi";
import HeaderSearch from "./HeaderSearch";
const GoodsList = () => {
  let history = useNavigate();

  const [init, setInit] = useState(0);
  const [init2, setInit2] = useState(0);
  const [contents, setContents] = useState("");
  const [kind, setKind] = useState<string | null>("");
  const [total, setTotal] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(8);
  const [page, setPage] = useState(1);
  const [list, setList] = useState<
    | [
        {
          img: "";
          kindNm: "";
          title: "";
          salePrice: 0;
          tagMsg: "";
          discountRate: "";
        }
      ]
    | null
  >(null);

  const selectedItem = (itemNum: any) => {
    history("/detail?itemNum=" + itemNum);
  };

  const getGoodsList = async (searchPage = page) => {
    let cateCd = kind;
    let searchContents = contents;

    if (init === 0) {
      const current = decodeURI(window.location.href);
      const search = current.split("?")[1];
      const params = new URLSearchParams(search);

      let keywordsCateCd = params.get("cateCd");
      let keywordsContents = params.get("contents");
      let keywordsPage = params.get("page");

      if (keywordsCateCd !== null) {
        cateCd = keywordsCateCd;
        setKind(keywordsCateCd);
      }
      if (keywordsContents !== null) {
        searchContents = keywordsContents;
        setContents(searchContents);
      }
      if (keywordsPage !== null) {
        searchPage = Number(keywordsPage);
        setPage(searchPage);
      }

      setInit(1);
    }

    if (page !== searchPage) {
      setPage(searchPage);
      return;
    }

    let data = await requestGet("/api/goods/list", {
      contents: searchContents,
      kind: cateCd,
      page: searchPage - 1,
      pageSize: pageSize,
    });
    let d = data.list;
    let dataList = d.content;

    setList(dataList);
    setTotal(d.totalPages);
    setTotalElements(d.totalElements);

    history(
      "/goods?cateCd=" +
        cateCd +
        "&contents=" +
        searchContents +
        "&page=" +
        searchPage
    );
    setInit2(1);
  };

  const onSearchGoods = () => {
    if (init2 === 1) {
      getGoodsList(1);
    }
  };

  const textLineBreak = (text: string) => {
    let arr: string[] = [];
    arr = text.split("@");

    if (arr[1] !== undefined) {
      let arr2 = arr.slice(1, arr.length);
      return (
        <span className="title">
          {arr[0]}
          <br></br>
          {arr2.map((char: any) => char)}
        </span>
      );
    } else {
      return (
        <span
          className="title title-m-size"
          style={{
            position: "absolute",
            // width: "250px",
            transform: "translate(-50%, 50%)",
          }}
        >
          {text}
        </span>
      );
    }
  };
  const tagLineBreak = (text: string) => {
    let arr = text.split("#");
    return arr.map((char: any, index: any) => (
      <div key={index}>
        <span className="tag">#{char}</span>
        <br></br>
      </div>
    ));
  };

  const priceToString = (item: any, p: any) => {
    let price = item.salePrice;
    if (p === "price") {
      price = item.price;
    }
    let num = price;
    if (item.kindNm === "건강기능식품" || item.kindNm === "건강(기능)식품") {
      let calculation = price;
      num = calculation.toFixed();
    }
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  useEffect(() => {
    if (init === 1) {
      setInit2(1);
      onSearchGoods();
    }
  }, [kind]);

  useEffect(() => {
    getGoodsList();
  }, [page]);

  return (
    <Layout>
      <HeaderSearch
        medmall_logo={medmall_logo}
        contents={contents}
        setContents={setContents}
        onSearchGoods={onSearchGoods}
      ></HeaderSearch>
      <div className="div-left-search-m">
        <input placeholder="Search"></input>
        <img src="/svg/search.svg" alt="search" />
      </div>
      <div>
        <Categroy setKind={setKind} setContents={setContents}></Categroy>
      </div>
      <div className="web-template-list-form">
        <div style={{ marginTop: "24px" }}>
          <span className="span-item-count">
            총<label>{totalElements}</label>개 상품
          </span>
        </div>
      </div>
      <div className="img-goods-list">
        <ul>
          {list !== null && totalElements !== 0 ? (
            list.map((item: any, index: any) => (
              <li onClick={() => selectedItem(item.seq)} key={index}>
                <div className="item">
                  <div className="div-goods-kind">
                    <div>
                      <span>
                        {item.kindNm === "건강기능식품(단품)"
                          ? "건강기능식품"
                          : item.kindNm}
                      </span>
                    </div>
                  </div>
                  <div className="img-goods-img border-solid-gray">
                    <img
                      src={
                        API_SERVER_URL +
                        "/api/goods/show?kind=T&filename=" +
                        item.img
                      }
                      alt="img"
                      style={{ display: "inline" }}
                    ></img>
                  </div>
                  <div className="div-goods-title margin-bottom-10">
                    {textLineBreak(item.title)}
                  </div>
                  <div className="div-goods-title">
                    {item.tagMsg && tagLineBreak(item.tagMsg)}
                  </div>
                  {/* <div className="div-goods-price">
                    <span className="price-label">최저가격</span>
                    <span className="price">{priceToString(item)}</span>
                    <span className="price-unit">원/개</span>
                    <span className="price">
                      ({item.discountRate !== 0 ? item.discountRate : "00"}%)
                    </span>
                  </div> */}
                  <div className="div-goods-price">
                    <div>
                      <div style={{ float: "left" }}>
                        <span className="price-label">소비자가</span>
                      </div>
                      <div style={{ float: "right" }}>
                        <span
                          className="price"
                          style={{ textDecoration: "line-through" }}
                        >
                          {priceToString(item, "price")}
                        </span>
                        <span className="price-unit">원/개</span>
                      </div>
                    </div>
                  </div>
                  <div className="div-goods-price">
                    <div>
                      <div style={{ float: "left" }}>
                        <span className="price-label">최저가격</span>
                      </div>
                      <div style={{ float: "right" }}>
                        <span className="price">
                          ({item.discountRate !== 0 ? item.discountRate : "00"}%
                          <label>↓</label>)
                        </span>
                        <span className="price">
                          {priceToString(item, "salePrice")}
                        </span>
                        <span className="price-unit">원/개</span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))
          ) : (
            <div>
              {init === 1 && (
                <div>
                  <br></br>
                  <br></br>
                  <span>등록된 상품이 없습니다.</span>
                  <br></br>
                  <br></br>
                </div>
              )}
            </div>
          )}
        </ul>
        <br></br>
      </div>

      <div>
        {total > 1 && (
          <Pagenation total={total} page={page} setPage={setPage}></Pagenation>
        )}
      </div>
      <div style={{ clear: "both", marginBottom: "35px" }}></div>
    </Layout>
  );
};

export default GoodsList;
